import "./NordVPNVsSurfshark.module.css";
import Header from "@/reusable_sections/Header";
import Comparisonhero from "./sections/Comparisonhero";
import Comparison from "./sections/Comparison";
import Relatedvpnarticles from "./sections/Relatedvpnarticles";
import Footer from "@/reusable_sections/Footer";
export default function NordVPNVsSurfsharkPage() {
  return <div>
      <Header />
      <Comparisonhero />
      <Comparison />
      <Relatedvpnarticles />
      <Footer />
    </div>;
}